import { render, staticRenderFns } from "./CompensatoryDetail.vue?vue&type=template&id=34598e47&"
import script from "./CompensatoryDetail.vue?vue&type=script&lang=js&"
export * from "./CompensatoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports